/**
 * Self-hosted webfonts (via @fontsource — NO CDN). Imported once at app start.
 *
 * Type system (deliberately off the Inter/Roboto/Geist "slop" axis):
 *   - Headings: Bricolage Grotesque — a characterful editorial grotesque with real
 *     personality (a tight, confident display voice).
 *   - Body / UI / data: IBM Plex Sans — a clean, neutral humanist sans that is a
 *     genuine contrast partner to the display face and stays quiet at data density.
 *   - Mono: IBM Plex Mono — for ids / tokens / JSON / code.
 *
 * The font-family *names* below must match the CSS families these packages register,
 * and are consumed by `tokens.fonts` in `tokens.ts`.
 */
import '@fontsource-variable/bricolage-grotesque';
import '@fontsource-variable/ibm-plex-sans';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/ibm-plex-mono/600.css';

export const fontFamilies = {
  heading:
    "'Bricolage Grotesque Variable', 'Bricolage Grotesque', ui-sans-serif, system-ui, sans-serif",
  body: "'IBM Plex Sans Variable', 'IBM Plex Sans', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', sans-serif",
  mono: "'IBM Plex Mono', ui-monospace, 'SFMono-Regular', 'Menlo', 'Consolas', monospace",
} as const;
